import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BasketIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5 6.73053V4.48053C5 2.96175 6.23122 1.73053 7.75 1.73053H8.25C9.76878 1.73053 11 2.96175 11 4.48053V6.73053H12.5525C12.8073 6.73053 13.0213 6.9221 13.0495 7.17531L13.8767 14.6201C13.9425 15.2124 13.4788 15.7305 12.8828 15.7305H3.11731C2.52129 15.7305 2.0576 15.2124 2.12342 14.6201L2.95062 7.17531C2.97876 6.9221 3.19279 6.73053 3.44756 6.73053H5ZM6.5 4.48053C6.5 3.79017 7.05964 3.23053 7.75 3.23053H8.25C8.94036 3.23053 9.5 3.79017 9.5 4.48053V6.73053H6.5V4.48053ZM5 7.98047V8.73053C5 9.14474 5.33579 9.48053 5.75 9.48053C6.16421 9.48053 6.5 9.14474 6.5 8.73053V7.98041C6.80364 8.20846 7.00004 8.57156 7.00004 8.98053C7.00004 9.67089 6.4404 10.2305 5.75004 10.2305C5.05969 10.2305 4.50004 9.67089 4.50004 8.98053C4.50004 8.57159 4.69641 8.20852 5 7.98047ZM9.5 7.98047V8.73053C9.5 9.14474 9.83579 9.48053 10.25 9.48053C10.6642 9.48053 11 9.14474 11 8.73053V7.98041C11.3036 8.20846 11.5 8.57156 11.5 8.98053C11.5 9.67089 10.9404 10.2305 10.25 10.2305C9.55969 10.2305 9.00004 9.67089 9.00004 8.98053C9.00004 8.57159 9.19641 8.20852 9.5 7.98047Z"
		/>
	</svg>
))
